const normalizeControlPanelValue = (value) => {
  if (typeof value !== 'string') {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  return value.trim();
};

export const isControlPanelJobComplete = (job) => {
  const controlPanelDone = normalizeControlPanelValue(job?.ControlPanelDone);
  return controlPanelDone !== '';
};

export const hasControlPanelDueDate = (job) => {
  const controlPanelDue = normalizeControlPanelValue(job?.ControlPanelDue);
  if (controlPanelDue === '') {
    return false;
  }

  const dueDate = new Date(controlPanelDue);
  return !Number.isNaN(dueDate.getTime());
};

export const isControlPanelViewJob = (job) => {
  if (!job || !hasControlPanelDueDate(job)) {
    return false;
  }

  return !isControlPanelJobComplete(job);
};

export const compareControlPanelDueDates = (leftJob, rightJob) => {
  const leftDue = leftJob?.ControlPanelDue;
  const rightDue = rightJob?.ControlPanelDue;

  if (!leftDue && !rightDue) return 0;
  if (!leftDue) return 1;
  if (!rightDue) return -1;

  const leftDate = new Date(leftDue);
  const rightDate = new Date(rightDue);

  if (Number.isNaN(leftDate.getTime()) && Number.isNaN(rightDate.getTime())) return 0;
  if (Number.isNaN(leftDate.getTime())) return 1;
  if (Number.isNaN(rightDate.getTime())) return -1;

  return leftDate - rightDate;
};

export const sortJobsByControlPanelDue = (jobs) => {
  if (!Array.isArray(jobs)) {
    return [];
  }

  return [...jobs].sort(compareControlPanelDueDates);
};
